module.exports = __webpack_public_path__ + "static/media/face-with-raised-eyebrow-svgrepo-com.959453d7.svg";